"use client";
import React from "react";
// import { useDictionary } from "../DictProvider/DictProvider";
import { usePathname } from "next/navigation";

const Page = ({
  checkInternetConnection,
}: {
  checkInternetConnection: any;
}) => {
  // const dict = useDictionary();
  const pathName = usePathname();
  return (
    <div className="flex flex-col items-center justify-center min-h-screen w-full">
      <div className="flex flex-col items-center space-y-4 ">
        <svg
          width="196"
          height="196"
          viewBox="0 0 196 196"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2993_13568)">
            <path
              d="M97.5013 152.214C103.622 152.214 108.585 147.251 108.585 141.13C108.585 135.009 103.622 130.047 97.5013 130.047C91.3801 130.047 86.418 135.009 86.418 141.13C86.418 147.251 91.3801 152.214 97.5013 152.214Z"
              fill="#0DB3A9"
            />
            <path
              d="M138.81 97.4158L139.216 96.7878C139.617 96.1661 139.891 95.4708 140.021 94.7424C140.15 94.014 140.134 93.2671 139.973 92.545C139.811 91.823 139.507 91.1404 139.079 90.5368C138.651 89.9333 138.108 89.4209 137.48 89.0295C125.468 81.6087 111.626 77.6812 97.506 77.6875C95.4371 77.6875 93.4052 77.6875 91.4102 77.9461L103.269 89.8053C113.225 90.6837 122.839 93.8715 131.347 99.1153C132.568 99.8554 134.03 100.092 135.422 99.7748C136.815 99.4577 138.029 98.6118 138.81 97.4158Z"
              fill="#0DB3A9"
            />
            <path
              d="M152.03 66.6631C139.717 58.9838 125.922 53.9908 111.546 52.0109C97.1711 50.0309 82.5396 51.1086 68.6094 55.1734L78.3258 64.8898C101.539 59.9063 125.781 64.1742 145.897 76.7859C147.112 77.5035 148.556 77.7273 149.931 77.411C151.306 77.0948 152.507 76.2627 153.286 75.0865L153.692 74.4584C154.103 73.8398 154.385 73.1455 154.524 72.4162C154.663 71.687 154.654 70.9374 154.499 70.2114C154.344 69.4854 154.046 68.7976 153.622 68.1884C153.198 67.5791 152.657 67.0605 152.03 66.6631Z"
              fill="#0DB3A9"
            />
            <path
              d="M42.0839 49.5607L53.5367 61.0135C49.8254 62.7241 46.2226 64.6612 42.7489 66.8138C42.113 67.2022 41.5613 67.7141 41.1264 68.3193C40.6916 68.9244 40.3824 69.6105 40.2171 70.3372C40.0518 71.0638 40.0338 71.8162 40.164 72.5499C40.2943 73.2836 40.5703 73.9838 40.9756 74.6091L41.382 75.2371C42.1612 76.4133 43.3622 77.2454 44.7372 77.5617C46.1122 77.8779 47.5561 77.6542 48.7709 76.9366C53.0864 74.2221 57.6218 71.8741 62.3295 69.9171L73.93 81.5177C68.0592 83.404 62.4394 85.9968 57.1942 89.2391C56.5693 89.6335 56.0291 90.1481 55.6047 90.753C55.1804 91.3579 54.8805 92.0411 54.7224 92.7629C54.5643 93.4847 54.5511 94.2307 54.6837 94.9576C54.8163 95.6846 55.092 96.3779 55.4948 96.9974L55.9012 97.6255C56.6803 98.8017 57.8814 99.6338 59.2564 99.95C60.6314 100.266 62.0753 100.042 63.29 99.3249C69.5585 95.4509 76.4431 92.6771 83.6464 91.1232L96.9464 104.423C88.0977 104.515 79.4353 106.977 71.8612 111.554C71.2375 111.944 70.698 112.456 70.2741 113.057C69.8502 113.659 69.5504 114.339 69.3922 115.058C69.234 115.777 69.2206 116.52 69.3527 117.244C69.4848 117.968 69.7598 118.658 70.1617 119.275L70.5312 119.866C71.3441 121.068 72.5905 121.908 74.0092 122.211C75.4279 122.514 76.9088 122.256 78.1417 121.492C83.1139 118.538 88.6992 116.768 94.465 116.32C100.231 115.871 106.023 116.756 111.392 118.905L138.139 145.616L143.349 140.407L47.2931 44.3516L42.0839 49.5607Z"
              fill="#0DB3A9"
            />
          </g>
          <circle cx="98" cy="98" r="98" fill="#0DB3A9" fill-opacity="0.08" />
          <defs>
            <clipPath id="clip0_2993_13568">
              <rect
                width="133"
                height="133"
                fill="white"
                transform="translate(31 32)"
              />
            </clipPath>
          </defs>
        </svg>

        <div className="text-lg font-[600] mt-4">
          {/* {dict?.paymentErrorPage?.noInternet} */}
          {pathName?.split("/").includes("en")
            ? "No Internet Connection"
            : "لا يوجد اتصال بالإنترنت"}
        </div>
        <p className="text-center  px-4 text-sm sm:text-lg font-[400] text-[#666666] sm:whitespace-nowrap flex items-center justify-center md:justify-start">
          {/* {dict?.paymentErrorPage?.noInternetDesc} */}
          {pathName?.split("/").includes("en")
            ? "It looks like you’re offline. Please check your network settings and try again."
            : "يبدو أنك غير متصل بالإنترنت. يرجى التحقق من إعدادات الشبكة والمحاولة مرة أخرى."}
        </p>
        <button
          onClick={checkInternetConnection}
          className="bg-primary text-nowrap text-white text-xs font-[600] py-2 px-4 rounded-md mt-4 max-w-min"
        >
          {/* {dict?.paymentErrorPage?.errorBtn} */}
          {pathName?.split("/").includes("en") ? "Try again" : "حاول مرة أخرى"}
        </button>
      </div>
    </div>
  );
};

export default Page;
